// src/components/PushNotificationBridge.jsx
//
// Mount point for the usePushNotifications hook. Lives INSIDE the React
// Router (uses useNavigate) and inside AuthContext (uses useAuth).
// Renders nothing.
//
// Web builds: no-op (web push handled by service worker bridge in
// src/firebase/messaging.js — different code path).
//
// Capacitor iOS / Android: requests push permission, registers FCM
// token to users/{uid}/fcmTokens/, and routes notification taps via
// React Router so the user lands on the screen the push was about
// (not just the last screen they had open).

import usePushNotifications from '@/hooks/usePushNotifications';

export default function PushNotificationBridge() {
  usePushNotifications();
  return null;
}
